import {
  ShowChartIcon,
  BarChartIcon,
  ScatterPlotIcon,
  PieChartIcon,
  MultilineChartIcon,
} from '@gogame/components';

export const CHART_ICONS = {
  line: <ShowChartIcon />,
  bar: <BarChartIcon />,
  scatter: <ScatterPlotIcon />,
  pie: <PieChartIcon />,
  mixedChart: <MultilineChartIcon />,
};
